import { faSpinnerThird as fadSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';

import { DrawerBody, Icon } from '@growtherapy/sprout-ui';

import { INTAKE_SUMMARY_SOURCE, IntakeSummaryConnected } from '@grow-therapy-team/seedling-components';

import { ClientInformationDrawerHeader } from './ClientInformationDrawerHeader';
import { FormResponse } from './FormResponse';
import { FormListItem } from './form-list-item';
import { FormType, GroupedFormData } from './types';

type ClientInformationFormResponseDrawerProps = {
  selectedForms?: GroupedFormData[];
  revealResults?: boolean;
  selectedFormTitle: string;
  onClickForm?: (i: number) => void;
  onClickBackButton: () => void;
  formEntry?: number;
  appointmentShortId?: string;
  isLoading?: boolean;
};

export function ClientInformationFormResponseDrawer({
  selectedForms,
  selectedFormTitle,
  formEntry = 0,
  onClickBackButton,
  onClickForm,
  revealResults,
  appointmentShortId,
  isLoading,
}: ClientInformationFormResponseDrawerProps) {
  if (isLoading) {
    return (
      <>
        <ClientInformationDrawerHeader drawerTitle={selectedFormTitle} onClickBackButton={onClickBackButton} />
        <DrawerBody>
          <div className='flex justify-center'>
            <Icon
              aria-hidden={false}
              aria-label='Loading...'
              size='xl'
              data-testid='client-information.forms.loading'
              className='text-ivy-500 fa-spin'
              icon={fadSpinnerThird}
            />
          </div>
        </DrawerBody>
      </>
    );
  }

  if (!selectedForms) return null;

  const drawerTitle =
    selectedForms[0].formType === FormType.Gad7 || selectedForms[0].formType === FormType.Phq9
      ? `${selectedForms[0].formType} - ${selectedFormTitle}`
      : selectedFormTitle;

  const selectedForm = selectedForms[formEntry];
  const showIntakeSummary = revealResults && selectedForm?.formType === FormType.Intake && !!appointmentShortId;

  return (
    <>
      <ClientInformationDrawerHeader drawerTitle={drawerTitle} onClickBackButton={onClickBackButton} />
      <DrawerBody>
        {!revealResults ? (
          <span data-testid='client-information.forms.form-list'>
            {selectedForms.map((form, i) => (
              <FormListItem
                form={form}
                key={`${form.formType}-${i}`}
                onClick={() => {
                  onClickForm?.(i);
                }}
              />
            ))}
          </span>
        ) : (
          <>
            {showIntakeSummary && (
              <div className='mb-4'>
                <IntakeSummaryConnected
                  appointmentShortId={appointmentShortId}
                  showViewFullIntakeButton={false}
                  shouldTruncateSummaryText={false}
                  source={INTAKE_SUMMARY_SOURCE.FORM_RESPONSE}
                  isInverse
                />
              </div>
            )}
            <FormResponse selectedForm={selectedForm} />
          </>
        )}
      </DrawerBody>
    </>
  );
}
